<template>
  <div class="page flex-col">
    <div class="box_4 flex-col"></div>
    <span class="text_7">人工智能+人工智能商城平台项目扶持说明</span>
    <div class="image-wrapper_1 flex-row justify-between">
      <img
        class="image_2"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng031e078f116d99b06f0ca168149f62580a7eef1ea9101d7305e6364de5093080.png"
      />
      <img
        class="image_3"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng6f890c4f2068a38f74974885cadba83005f93c9f5f47ec53bb19f0fc131b03ab.png"
      />
      <img
        class="image_4"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPngc8812316309812294af6b18766c6ff8699eb1296686d15196605c66fd620d3a9.png"
      />
    </div>
    <div class="image-wrapper_2 flex-row justify-between">
      <img
        class="image_5"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng6f890c4f2068a38f74974885cadba83005f93c9f5f47ec53bb19f0fc131b03ab.png"
      />
      <img
        class="image_6"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng718796f380d6ce02541da6d48f62419f747e0a617f17b8260967d7f20606b956.png"
      />
    </div>
    <span class="text_8">相关扶持案例</span>
    <div class="box_5 flex-row justify-between">
      <div class="box_6 flex-col">
        <div class="image-text_1 flex-col justify-between">
          <div class="box_7 flex-col"></div>
          <div class="text-group_1 flex-col justify-between">
            <span class="text_9">标准版</span>
            <span class="text_10">数智通衢&nbsp;彩“云”之南</span>
          </div>
        </div>
        <div class="text-wrapper_1 flex-col"><span class="text_11">查看详情</span></div>
      </div>
      <div class="box_8 flex-col">
        <div class="image-text_2 flex-col justify-between">
          <div class="block_1 flex-col"></div>
          <div class="text-group_2 flex-col justify-between">
            <span class="text_12">高级版</span>
            <span class="text_13">铝行记：铝工业智能化纪录片</span>
          </div>
        </div>
        <div class="text-wrapper_2 flex-col"><span class="text_14">查看详情</span></div>
      </div>
      <div class="box_9 flex-col">
        <div class="image-text_3 flex-col justify-between">
          <div class="group_2 flex-col"></div>
          <span class="text-group_3">顶级版</span>
        </div>
        <span class="text_15">从埃塞俄比亚高原到全球云端：一颗咖啡豆的数字蜕变之旅</span>
        <div class="text-wrapper_3 flex-col"><span class="text_16">查看详情</span></div>
      </div>
    </div>
    <div class="box_10 flex-row justify-between">
      <div class="box_11 flex-col">
        <div class="image-text_4 flex-col justify-between">
          <div class="box_12 flex-col"></div>
          <div class="text-group_4 flex-col justify-between">
            <span class="text_17">标准版</span>
            <span class="text_18">数智通衢&nbsp;彩“云”之南</span>
          </div>
        </div>
        <div class="text-wrapper_4 flex-col"><span class="text_19">查看详情</span></div>
      </div>
      <div class="box_13 flex-col">
        <div class="image-text_5 flex-col justify-between">
          <div class="box_14 flex-col"></div>
          <div class="text-group_5 flex-col justify-between">
            <span class="text_20">高级版</span>
            <span class="text_21">铝行记：铝工业智能化纪录片</span>
          </div>
        </div>
        <div class="text-wrapper_5 flex-col"><span class="text_22">查看详情</span></div>
      </div>
      <div class="box_15 flex-col">
        <div class="image-text_6 flex-col justify-between">
          <div class="group_3 flex-col"></div>
          <span class="text-group_6">顶级版</span>
        </div>
        <span class="text_23">从埃塞俄比亚高原到全球云端：一颗咖啡豆的数字蜕变之旅</span>
        <div class="text-wrapper_6 flex-col"><span class="text_24">查看详情</span></div>
      </div>
    </div>
    <SiteFooter />
  </div>
</template>
<script>
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  components: { SiteFooter },
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="less" src="./assets/index.less" />